/* eslint-disable no-extend-native */
/* eslint-disable no-var */
/* eslint-disable no-useless-escape */
/* eslint-disable no-new */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react-hooks/rules-of-hooks */
import { IDateGridStrings } from "@fluentui/date-time-utilities";
import { ICalendarStrings, IDateFormatting } from "@fluentui/react";
import { useLocation, useParams } from "react-router-dom";
import dayjs from "./dayjs";

// 定义翻译函数类型
type TFunction = (key: string, options?: any) => string;

/**
 * 自定义安全错误类
 * 用于安全验证失败时抛出，前端可以捕获并友好展示
 */
export class SecurityError extends Error {
  public readonly code: string;
  public readonly severity: "warning" | "error" | "critical";
  public readonly userMessage: string;
  public readonly details: any;

  constructor (
    message: string,
    code = "SECURITY_VIOLATION",
    severity: "warning" | "error" | "critical" = "error",
    userMessage = "输入内容包含不安全字符，请检查后重试",
    details?: any
  ) {
    super(message);
    this.name = "SecurityError";
    this.code = code;
    this.severity = severity;
    this.userMessage = userMessage;
    this.details = details;
  }

  /**
   * 获取用户友好的错误信息
   */
  getUserMessage (): string {
    return this.userMessage;
  }

  /**
   * 判断是否应该阻止操作继续
   */
  shouldBlockOperation (): boolean {
    return this.severity === "error" || this.severity === "critical";
  }
}

export const IsIsNullOrEmpty = (data: any) => {
  return !!(data === "" || data === null || data === undefined);
};

export const setToken = (token: string) => window.localStorage.setItem("auth_token", token);

export const getToken = () => window.localStorage.getItem("auth_token");

export const clearToken = () => window.localStorage.removeItem("auth_token");

export const setLocalStorage = (name: string, content: any) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content) || "";
  }
  window.localStorage.setItem(name, content);
};

export const getLocalStorage = (name: string) => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

export const removeLocalStorage = (name: string) => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

const utc2beijing = (utc_datetime: string, separator?: string, isShowHour?: boolean) => {
  let T_pos = utc_datetime.indexOf("T");
  let Z_pos = utc_datetime.indexOf("Z");
  let year_month_day = utc_datetime.substr(0, T_pos);
  let hour_minute_second = utc_datetime.substr(T_pos + 1, Z_pos - T_pos - 1);
  let new_datetime = year_month_day + " " + hour_minute_second;

  timestamp = new Date(Date.parse(new_datetime));
  timestamp = timestamp.getTime();
  timestamp = timestamp / 1000;

  // eslint-disable-next-line no-var
  var timestamp: any = timestamp + 8 * 60 * 60;
  let time: any = new Date(parseInt(timestamp) * 1000);
  let year = time.getFullYear();
  let month = ("0" + (time.getMonth() + 1)).slice(-2);
  let day = ("0" + time.getDate()).slice(-2);
  let beijing_datetime = year + separator + month + separator + day;
  beijing_datetime = isShowHour
    ? beijing_datetime + " " + ("0" + time.getHours()).slice(-2) + ":" + ("0" + time.getMinutes()).slice(-2)
    : beijing_datetime;
  return beijing_datetime;
};

const utcLocalDate = (utc_datetime: string, separator?: string, isShowHour?: boolean) => {
  let time: any = new Date(utc_datetime);
  let year = time.getFullYear();
  let month = ("0" + (time.getMonth() + 1)).slice(-2);
  let day = ("0" + time.getDate()).slice(-2);
  let beijing_datetime = year + separator + month + separator + day;
  beijing_datetime = isShowHour
    ? beijing_datetime + " " + ("0" + time.getHours()).slice(-2) + ":" + ("0" + time.getMinutes()).slice(-2)
    : beijing_datetime;
  return beijing_datetime;
};
export const ToBeijing = (utcTime: any, separator?: string, isShowHour?: boolean) => {
  separator = separator || "-";
  isShowHour = isShowHour || false;
  const utcDate = new Date(utcTime).toISOString();
  return utc2beijing(utcDate, separator, isShowHour);
};

export const ToLocalDate = (utcTime: any, separator?: string, isShowHour?: boolean) => {
  separator = separator || "-";
  isShowHour = isShowHour || false;
  const utcDate = new Date(utcTime).toISOString();
  return utcLocalDate(utcDate, separator, isShowHour);
};

export const incrementSecondsIfFiftyNine = (time: string) => {
  const parts = time.split(":").map(Number);
  if (parts[1] === 59) {
    parts[1] = 0;
    parts[0]++;
  }
  return parts.map(val => ("0" + val).slice(-2)).join(":");
};

export const ToHours = (utcTime: any) => {
  const utcDate = new Date(utcTime).toISOString();
  let T_pos = utcDate.indexOf("T");
  let Z_pos = utcDate.indexOf("Z");
  let year_month_day = utcDate.substr(0, T_pos);
  let hour_minute_second = utcDate.substr(T_pos + 1, Z_pos - T_pos - 1);
  let new_datetime = year_month_day + " " + hour_minute_second;

  timestamp = new Date(Date.parse(new_datetime));
  timestamp = timestamp.getTime();
  timestamp = timestamp / 1000;

  // eslint-disable-next-line no-var
  // var timestamp: any = timestamp + 8 * 60 * 60;
  var timestamp: any = timestamp + getutcOffset() * 60 * 60;
  let time: any = new Date(parseInt(timestamp) * 1000);
  return ("0" + time.getHours()).slice(-2) + ":" + ("0" + time.getMinutes()).slice(-2);
};
export const ToLocalHours = (utcTime: any) => {
  const utcDate = new Date(utcTime).toISOString();

  let time: any = new Date(utcDate);
  return ("0" + time.getHours()).slice(-2) + ":" + ("0" + time.getMinutes()).slice(-2);
};

export const ToTimeZoneHours = (utcTime: any) => {
  const utcDate = getTimeZone(new Date(utcTime), getutcOffset());
  let time: any = new Date(utcDate);
  return ("0" + time.getHours()).slice(-2) + ":" + ("0" + time.getMinutes()).slice(-2);
};

export const getParameter = (param: string) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  return query.get(param);
};

export const getPathName = () => {
  const location = useLocation();
  const { pathname } = location;
  return pathname;
};

export const getParams = () => {
  return useParams();
};

export const getItem = (column: Array<any>, item: any) => {
  let obj: any = {};
  column.forEach((val: any) => {
    obj[val.columnKey] = {
      label: item[val.columnKey],
    };
    return obj;
  });
  return obj;
};

export const getItems = (column: Array<any>, items?: Array<any>) => {
  if (items && items.length > 0) {
    let columnKeys = Object.keys(items[0]);
    return items.map((item: any) => {
      let obj: any = {};
      column
        .filter(val => val.columnKey !== "")
        .forEach((val: any) => {
          columnKeys = columnKeys.filter(sonItem => sonItem !== val.columnKey);
          columnKeys.forEach((sonVal: any) => {
            obj[sonVal] = item[sonVal];
          });
          obj[val.columnKey] = {
            label: val.type === "date" ? setValue(val.type, item[val.columnKey], val.separator) : setValue(val.type, item[val.columnKey]),
          };
        });
      return {
        ...obj,
        itemDatas: item,
        hasChildren: item.hasChildren,
        childItem: item.childItem,
      };
    });
  }
  return [];
};

const setValue = (type: string, item: any, separator?: string) => {
  let value: any;
  switch (type) {
    case "date":
      value = isNaN(item) && !isNaN(Date.parse(item)) ? ToLocalDate(item, separator) : item;
      break;
    case "number":
      value = Number(item);
      break;
    case "millage":
      value = numFormat(item);
      break;
    default:
      value = item;
      break;
  }
  return value;
};

export const numFormat = (num: any) => {
  if (num === undefined) return;
  let res = num.toString().replace(/\d+/, (n: any) => {
    return n.replace(/(\d)(?=(\d{3})+$)/g, ($1: any) => {
      return $1 + ",";
    });
  });
  return res;
};

export const getMSALInfo = () => {
  return JSON.parse(getLocalStorage("userInfo") as string);
};

export const createdCustomerInfo = () => {
  return JSON.parse(getLocalStorage("createdCustomer") || "");
};

export const localData = (name: string) => {
  if (getLocalStorage(name) === "") return;
  return JSON.parse(getLocalStorage(name) as string);
};

export const formatTime = (data: string) => {
  let date = new Date(data);
  let year: any = date.getFullYear();
  let month: any = date.getMonth() + 1;
  let day: any = date.getDate();
  let hours: any = date.getHours();
  let minutes: any = date.getMinutes();
  let seconds: any = date.getSeconds();

  month = ("0" + month).slice(-2);
  day = ("0" + day).slice(-2);
  hours = ("0" + hours).slice(-2);
  minutes = ("0" + minutes).slice(-2);
  seconds = ("0" + seconds).slice(-2);

  return `${year}年${month}月${day}日`;
};

// 国际化版本
export const formatTimeI18n = (data: string, t: TFunction) => {
  let date = new Date(data);
  let year: any = date.getFullYear();
  let month: any = date.getMonth() + 1;
  let day: any = date.getDate();
  let hours: any = date.getHours();
  let minutes: any = date.getMinutes();
  let seconds: any = date.getSeconds();

  month = ("0" + month).slice(-2);
  day = ("0" + day).slice(-2);
  hours = ("0" + hours).slice(-2);
  minutes = ("0" + minutes).slice(-2);
  seconds = ("0" + seconds).slice(-2);

  return `${year}${t("Common.dateTime.year")}${month}${t("Common.dateTime.month")}${day}${t("Common.dateTime.day")}`;
};

export const formatDateTime = (date: Date | null | undefined, format: string) => {
  if (!date?.getTime) {
    return "";
  }
  const opt: any = {
    "Y+": date.getFullYear(), // year
    "M+": date.getMonth() + 1, // month
    "d+": date.getDate(), // day
    "h+": date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // hour
    "H+": date.getHours(), // hour
    "m+": date.getMinutes(), // minute
    "s+": date.getSeconds(), // second
    "q+": Math.floor((date.getMonth() + 3) / 3), // quarter
    S: date.getMilliseconds(), // miliminute
    a: date.getHours() < 12 ? "上午" : "下午", // noon
    A: date.getHours() < 12 ? "AM" : "PM", // noon
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (const k in opt) {
    const ret = new RegExp("(" + k + ")").exec(format);
    if (ret) {
      if (/(y+)/.test(k)) {
        format = format.replace(ret[1], `${opt[k]}`.substring(4 - ret[1].length));
      } else {
        format = format.replace(ret[1], ret[1].length === 1 ? opt[k] : `${opt[k]}`.padStart(ret[1].length, "0"));
      }
    }
  }
  return format;
};

// 国际化版本
export const formatDateTimeI18n = (date: Date | null | undefined, format: string, t: TFunction) => {
  if (!date?.getTime) {
    return "";
  }
  const opt: any = {
    "Y+": date.getFullYear(), // year
    "M+": date.getMonth() + 1, // month
    "d+": date.getDate(), // day
    "h+": date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // hour
    "H+": date.getHours(), // hour
    "m+": date.getMinutes(), // minute
    "s+": date.getSeconds(), // second
    "q+": Math.floor((date.getMonth() + 3) / 3), // quarter
    S: date.getMilliseconds(), // miliminute
    a: date.getHours() < 12 ? t("Common.dateTime.morning") : t("Common.dateTime.afternoon"), // noon
    A: date.getHours() < 12 ? "AM" : "PM", // noon
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (const k in opt) {
    const ret = new RegExp("(" + k + ")").exec(format);
    if (ret) {
      if (/(y+)/.test(k)) {
        format = format.replace(ret[1], `${opt[k]}`.substring(4 - ret[1].length));
      } else {
        format = format.replace(ret[1], ret[1].length === 1 ? opt[k] : `${opt[k]}`.padStart(ret[1].length, "0"));
      }
    }
  }
  return format;
};

export const getCurrentCustomer = (cid: number) => {
  return localData("customers")?.customers?.filter((item: any) => item.customerId === cid);
};

export const getCurrentUID = () => {
  return localData("currentCustomer").userId;
};
export const getCurrentInfo = (field: string) => {
  try {
    return localData("currentCustomer")?.length > 0 ? localData("currentCustomer")[0][field] : localData("currentCustomer")[field];
  } catch (e) {}
};

export const getPrimaryPurpose = (code: number, data?: any) => {
  if (code === 1) {
    return "微软直客";
  } else if (code === 2) {
    return "KA代理";
  } else if (code === 3) {
    return "KA代理二代";
  } else if (code === 5) {
    return "LeadGen";
  } else {
    return "区域代理";
  }
};

// 国际化版本
export const getPrimaryPurposeI18n = (code: number, t: TFunction, data?: any) => {
  if (code === 1) {
    return t("Common.primaryPurpose.microsoftDirect");
  } else if (code === 2) {
    return t("Common.primaryPurpose.kaAgent");
  } else if (code === 3) {
    return t("Common.primaryPurpose.kaAgentSecond");
  } else if (code === 5) {
    return t("Common.primaryPurpose.leadGen");
  } else {
    return t("Common.primaryPurpose.regionalAgent");
  }
};

export const advertiserAuthenticationStatus = (code: number) => {
  if (code === 1) {
    return "已验证";
  } else {
    return "未验证";
  }
};

// 国际化版本
export const advertiserAuthenticationStatusI18n = (code: number, t: TFunction) => {
  if (code === 1) {
    return t("Common.authenticationStatus.verified");
  } else {
    return t("Common.authenticationStatus.unverified");
  }
};

export const userRole = (code: number) => {
  if (code === 1) {
    return "超级管理员";
  } else if (code === 2) {
    return "账号管理员";
  } else {
    return "查看人员";
  }
};

// 国际化版本
export const userRoleI18n = (code: number, t: TFunction) => {
  if (code === 1) {
    return t("Common.userRole.superAdmin");
  } else if (code === 2) {
    return t("Common.userRole.accountAdmin");
  } else {
    return t("Common.userRole.viewer");
  }
};

export const userStatus = (code: number) => {
  if (code === 0) {
    return "不活跃的";
  } else if (code === 1) {
    return "活跃";
  } else if (code === 2) {
    return "待接受邀请";
  } else {
    return "删除";
  }
};

// 国际化版本
export const userStatusI18n = (code: number, t: TFunction) => {
  if (code === 0) {
    return t("Common.userStatus.inactive");
  } else if (code === 1) {
    return t("Common.userStatus.active");
  } else if (code === 2) {
    return t("Common.userStatus.pendingInvitation");
  } else {
    return t("Common.userStatus.deleted");
  }
};

export const download = (res: any, filename: any) => {
  let blob = new Blob([res]);
  let a = document.createElement("a");
  let url = window.URL.createObjectURL(blob);
  a.target = "_blank";
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const getQueryVariable = (variable: any) => {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
};

export const isDuringDate = (dateList: any, currentSatrtDate: string, currentEndDate: string, disable: boolean) => {
  const result =
    dateList &&
    dateList.length > 0 &&
    dateList.map((date: any) => {
      if (
        (disable && getTimeZoneDate(currentEndDate, true) <= getTimeZoneDate(date.endTime, true)) ||
        (getTimeZoneDate(currentSatrtDate, true) >= getTimeZoneDate(date.startTime, true) &&
          getTimeZoneDate(currentEndDate, true) <= getTimeZoneDate(date.endTime, true))
      ) {
        return true;
      } else {
        return false;
      }
    });
  return result.length > 0 ? result.some((val: boolean) => val === true) : true;
};
export const getTimeStamp = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0");
  const date = now.getDate().toString().padStart(2, "0");
  const hour = now.getHours().toString().padStart(2, "0");
  const minute = now.getMinutes().toString().padStart(2, "0");
  const second = now.getSeconds().toString().padStart(2, "0");
  const millisecond = now.getMilliseconds().toString().padStart(3, "0");
  const formatted = `${year}${month}${date}${hour}${minute}${second}${millisecond}`;
  return formatted;
};

export const getFirstDay = (date: Date, timeZone: number): Date => {
  let utcDate = getTimeZone(date, timeZone);
  utcDate.setDate(1);
  return utcDate;
};

export const DateFormatting: IDateFormatting = {
  formatDay: (date: Date) => ("0" + date.getDate()).slice(-2),
  formatMonth: (date: Date, strings: IDateGridStrings) => ("0" + (date.getMonth() + 1)).slice(-2) + "月",
  formatYear: (date: Date) => ("0" + date.getFullYear()).slice(1) + "年",
  formatMonthDayYear: (date: Date, strings: IDateGridStrings) =>
    date.getFullYear() + "年" + ("0" + (date.getMonth() + 1)).slice(-2) + "月" + ("0" + date.getDate()).slice(-2),
  formatMonthYear: (date: Date, strings: IDateGridStrings) => {
    strings.days = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];

    strings.shortDays = ["日", "一", "二", "三", "四", "五", "六"];
    strings.months = ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];

    strings.shortMonths = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"];
    return date.getFullYear() + "年" + ("0" + (date.getMonth() + 1)).slice(-2) + "月";
  },
};

// 国际化版本的DateFormatting生成函数
export const createDateFormattingI18n = (t: TFunction): IDateFormatting => ({
  formatDay: (date: Date) => ("0" + date.getDate()).slice(-2),
  formatMonth: (date: Date, strings: IDateGridStrings) => ("0" + (date.getMonth() + 1)).slice(-2) + t("Common.dateTime.month"),
  formatYear: (date: Date) => ("0" + date.getFullYear()).slice(1) + t("Common.dateTime.year"),
  formatMonthDayYear: (date: Date, strings: IDateGridStrings) =>
    date.getFullYear() +
    t("Common.dateTime.year") +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    t("Common.dateTime.month") +
    ("0" + date.getDate()).slice(-2),
  formatMonthYear: (date: Date, strings: IDateGridStrings) => {
    strings.days = [
      t("Common.dateTime.weekdays.sunday"),
      t("Common.dateTime.weekdays.monday"),
      t("Common.dateTime.weekdays.tuesday"),
      t("Common.dateTime.weekdays.wednesday"),
      t("Common.dateTime.weekdays.thursday"),
      t("Common.dateTime.weekdays.friday"),
      t("Common.dateTime.weekdays.saturday"),
    ];

    strings.shortDays = [
      t("Common.dateTime.weekdaysShort.sunday"),
      t("Common.dateTime.weekdaysShort.monday"),
      t("Common.dateTime.weekdaysShort.tuesday"),
      t("Common.dateTime.weekdaysShort.wednesday"),
      t("Common.dateTime.weekdaysShort.thursday"),
      t("Common.dateTime.weekdaysShort.friday"),
      t("Common.dateTime.weekdaysShort.saturday"),
    ];
    strings.months = [
      t("Common.dateTime.months.january"),
      t("Common.dateTime.months.february"),
      t("Common.dateTime.months.march"),
      t("Common.dateTime.months.april"),
      t("Common.dateTime.months.may"),
      t("Common.dateTime.months.june"),
      t("Common.dateTime.months.july"),
      t("Common.dateTime.months.august"),
      t("Common.dateTime.months.september"),
      t("Common.dateTime.months.october"),
      t("Common.dateTime.months.november"),
      t("Common.dateTime.months.december"),
    ];

    strings.shortMonths = [
      t("Common.dateTime.monthsShort.january"),
      t("Common.dateTime.monthsShort.february"),
      t("Common.dateTime.monthsShort.march"),
      t("Common.dateTime.monthsShort.april"),
      t("Common.dateTime.monthsShort.may"),
      t("Common.dateTime.monthsShort.june"),
      t("Common.dateTime.monthsShort.july"),
      t("Common.dateTime.monthsShort.august"),
      t("Common.dateTime.monthsShort.september"),
      t("Common.dateTime.monthsShort.october"),
      t("Common.dateTime.monthsShort.november"),
      t("Common.dateTime.monthsShort.december"),
    ];

    // 判断当前语言，使用不同的格式
    const currentLang = t("Common.dateTime.year");
    if (currentLang === "年") {
      // 中文格式：2024年12月
      return date.getFullYear() + t("Common.dateTime.year") + ("0" + (date.getMonth() + 1)).slice(-2) + t("Common.dateTime.month");
    } else {
      // 英文格式：December 2024
      const monthNames = strings.months || [];
      const monthName = monthNames[date.getMonth()] || date.getMonth() + 1;
      return monthName + " " + date.getFullYear();
    }
  },
});

// 国际化版本的shortMonths生成函数
export const createShortMonthsI18n = (t: TFunction): string[] => [
  t("Common.dateTime.monthsNumeric.january"),
  t("Common.dateTime.monthsNumeric.february"),
  t("Common.dateTime.monthsNumeric.march"),
  t("Common.dateTime.monthsNumeric.april"),
  t("Common.dateTime.monthsNumeric.may"),
  t("Common.dateTime.monthsNumeric.june"),
  t("Common.dateTime.monthsNumeric.july"),
  t("Common.dateTime.monthsNumeric.august"),
  t("Common.dateTime.monthsNumeric.september"),
  t("Common.dateTime.monthsNumeric.october"),
  t("Common.dateTime.monthsNumeric.november"),
  t("Common.dateTime.monthsNumeric.december"),
];

// 国际化版本的LocalizedStrings生成函数
export const createLocalizedStringsI18n = (t: TFunction): ICalendarStrings => ({
  goToToday: t("Common.dateTime.current"),
  prevMonthAriaLabel: t("RangePicker.previousMonth") || "Previous month",
  nextMonthAriaLabel: t("RangePicker.nextMonth") || "Next month",
  prevYearAriaLabel: t("RangePicker.previousYear") || "Previous year",
  nextYearAriaLabel: t("RangePicker.nextYear") || "Next year",
  months: [
    t("Common.dateTime.months.january"),
    t("Common.dateTime.months.february"),
    t("Common.dateTime.months.march"),
    t("Common.dateTime.months.april"),
    t("Common.dateTime.months.may"),
    t("Common.dateTime.months.june"),
    t("Common.dateTime.months.july"),
    t("Common.dateTime.months.august"),
    t("Common.dateTime.months.september"),
    t("Common.dateTime.months.october"),
    t("Common.dateTime.months.november"),
    t("Common.dateTime.months.december"),
  ],
  shortMonths: [
    t("Common.dateTime.monthsShort.january"),
    t("Common.dateTime.monthsShort.february"),
    t("Common.dateTime.monthsShort.march"),
    t("Common.dateTime.monthsShort.april"),
    t("Common.dateTime.monthsShort.may"),
    t("Common.dateTime.monthsShort.june"),
    t("Common.dateTime.monthsShort.july"),
    t("Common.dateTime.monthsShort.august"),
    t("Common.dateTime.monthsShort.september"),
    t("Common.dateTime.monthsShort.october"),
    t("Common.dateTime.monthsShort.november"),
    t("Common.dateTime.monthsShort.december"),
  ],
  days: [
    t("Common.dateTime.weekdays.sunday"),
    t("Common.dateTime.weekdays.monday"),
    t("Common.dateTime.weekdays.tuesday"),
    t("Common.dateTime.weekdays.wednesday"),
    t("Common.dateTime.weekdays.thursday"),
    t("Common.dateTime.weekdays.friday"),
    t("Common.dateTime.weekdays.saturday"),
  ],
  shortDays: [
    t("Common.dateTime.weekdaysShort.sunday"),
    t("Common.dateTime.weekdaysShort.monday"),
    t("Common.dateTime.weekdaysShort.tuesday"),
    t("Common.dateTime.weekdaysShort.wednesday"),
    t("Common.dateTime.weekdaysShort.thursday"),
    t("Common.dateTime.weekdaysShort.friday"),
    t("Common.dateTime.weekdaysShort.saturday"),
  ],
});
export const shortMonths = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
export const LocalizedStrings: ICalendarStrings = {
  goToToday: "当前",
  prevMonthAriaLabel: "上一月",
  nextMonthAriaLabel: "下一月",
  prevYearAriaLabel: "上一年",
  nextYearAriaLabel: "下一年",
  months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
  shortMonths: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
  days: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
  shortDays: ["日", "一", "二", "三", "四", "五", "六"],
};

export const filterTreeData = (data: any, field: string, value: any) => {
  return data.filter((item: any) => {
    if (item[field] === value) {
      return true;
    }
    if (item.children) {
      item.children = filterTreeData(item.children, field, value);
      return item.children.length > 0;
    }
    return false;
  });
};

export const makeQueryStrings = (obj: { [key: string]: any }) => {
  const qsArr = [];
  for (let key in obj) {
    if (obj[key]) {
      qsArr.push(`${key}=${obj[key]}`);
    }
  }
  if (qsArr.length === 0) {
    return "";
  }
  return `?${qsArr.join("&")}`;
};

export const isArrayEqual = (arr1: any[], arr2: any[]) => {
  let flag = true;
  if (arr1.length !== arr2.length) {
    flag = false;
  } else {
    arr1.forEach(item => {
      if (!arr2.includes(item)) {
        flag = false;
      }
    });
  }
  return flag;
};
export const formatCommaNumber = (num: string) => {
  const numStr = `${num}`;
  const reg = /^\d+(\.\d)?\d*$/;
  if (reg.test(numStr)) {
    if (numStr.indexOf(".") >= 0) {
      return numStr.replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    } else {
      return numStr.replace(/\B(?=(?:\d{3})+\b)/g, ",");
    }
  }
  return numStr;
};
export const getCurrentValue = (data: any, field: string) => {
  return data ? data[field] : "";
};

export const validateTextField = (value: string, required: boolean, minLength: number, maxLength: number | undefined) => {
  if (required) {
    if (minLength <= 0) {
      minLength = 1;
    }
    if (strlen(value) < minLength) {
      return false;
    }
  }

  return maxLength === undefined || strlen(value) <= maxLength;
};

export const verifyDomain = (domain: any) => {
  let reg = /^(?:(http|https):\/\/)?((?:[\w-]+\.)+[a-z0-9]+)$/i;
  return reg.exec(domain);
};

export const enumTime = (step = 60) => {
  let currentStep: any = step;
  if (currentStep === 59) step = 60;
  let temp = [];
  let alLCount = 86400 / 60 / step;
  let hourCount = 60 / step;
  let hour: any = 0;
  let minute: any = 0;
  for (let i = 0; i < alLCount; i++) {
    if (i === 0 && hour === 0) {
      temp.push({
        text: currentStep === 59 ? "01:00" : "00:00",
        value: step * i,
        key: currentStep === 59 ? "00:59" : "00:00",
      });
    } else {
      if ((step * i) % 60 === 0) {
        minute = currentStep === 59 ? 59 : 0;
        hour = hour + 1;
      } else {
        minute = (step * i) % 60;
      }
      minute = minute < 10 ? "0" + minute : minute;
      let currentdata = currentStep === 59 ? i + 1 : hour;
      temp.push({
        text:
          parseInt(currentdata, 10) < 10
            ? `0${currentdata}:${currentStep === 59 ? "00" : minute}`
            : `${currentdata}:${minute === 59 ? "00" : minute}`,
        value: step * i,
        key: parseInt(hour, 10) < 10 ? "0" + hour + ":" + minute : hour + ":" + minute,
      });
    }
  }
  return temp;
};
export const classNames = (classObj: { [key: string]: boolean }, classArr?: string[]) => {
  const resultArr = [];
  for (let keys in classObj) {
    if (classObj[keys]) {
      resultArr.push(keys);
    }
  }
  if (classArr && Array.isArray(classArr)) {
    Array.prototype.push.apply(resultArr, classArr);
  }
  if (classArr && Array.isArray(classArr)) {
    Array.prototype.push.apply(resultArr, classArr);
  }
  return resultArr.join(" ");
};

export const verifyTelNumber = (value: any) => {
  const telNmber = /^0\d{2,3}-?\d{6,8}$/; // /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
  const phoneTest = /^1(3|4|5|6|7|8|9)\d{9}$/;
  return !!(telNmber.test(value) || phoneTest.test(value));
};

export const isSocialCode = (socialCode: any) => {
  const reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
  return reg.test(socialCode);
};
export const formatEndTime = (endTime: any) => {
  return ToLocalDate(endTime, "/", false) + " " + incrementSecondsIfFiftyNine(ToLocalHours(endTime));
};

export const formatTimZoneEndTime = (endTime: any) => {
  return getDate(endTime) + " " + incrementSecondsIfFiftyNine(getTimeZoneHour(endTime));
};

export const trim = (string: string) => {
  if (string.trim) {
    return string.trim();
  } else {
    let reg = /^\s+|\s+$/g;
    return string.replace(reg, "");
  }
};

export const blockingEvent = (e: any) => {
  e.stopPropagation();
  e.preventDefault();
};

export const replaceQueryString = (url: any, name: any, value: any) => {
  const re = new RegExp(name + "=[^&]*", "gi");
  return url.replace(re, name + "=" + value);
};

export const setHours = (date: any, h: number) => {
  const currentDate = new Date(ToLocalDate(date, "/", true));
  return new Date(currentDate.setHours(currentDate.getHours() + h));
};
export const setTimeZoneHours = (date: any, h: number) => {
  const currentDate = getTimeZone(new Date(date), getutcOffset());
  return new Date(currentDate.setHours(currentDate.getHours() + h));
};

export const setHoursMinutes = (date: any, h: number, m: number) => {
  const currentDate = new Date(ToLocalDate(date, "/", true));
  const hour = new Date(currentDate.setHours(currentDate.getHours() + h));
  return new Date(hour.setMinutes(currentDate.getMinutes() + m));
};

export const setTimeZoneHoursMinutes = (date: Date, h: number, m: number) => {
  const currentDate = getTimeZone(new Date(date), getutcOffset());
  const hour = new Date(currentDate.setHours(currentDate.getHours() + h));
  return new Date(hour.setMinutes(currentDate.getMinutes() + m));
};

export const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
};

export const separateChineseEnglish = (arr: any[]) => {
  let chinese: any[] = [];
  let english: any[] = [];

  if (findChineseNumberWithSymbolsDuplicates(arr.join(",")).length > 0) {
    chinese = findChineseNumberWithSymbolsDuplicates(arr.join(","));
  } else if (findEnglishWithSymbolsDuplicates(arr.join(",")).length > 0) {
    english = findEnglishWithSymbolsDuplicates(arr.join(","));
  }

  return { chinese, english };
};
const findEnglishWithSymbolsDuplicates = (input: string) => {
  // 匹配如 test、TEST、[test]、{Test}、(test) 等
  const words = input.match(/[\[\{\(]?([a-zA-Z]+)[\]\}\)]?/g);
  if (!words) return [];
  // 统一转小写并去除外部符号用于比较
  const normalize = (w: string): string => (typeof w === "string" ? w.replace(/^[\[\{\(]+|[\]\}\)]+$/g, "").toLowerCase() : "");
  const seen = new Set<string>();
  const duplicates = new Set<string>();
  for (const word of words) {
    const key = normalize(word);
    if (seen.has(key)) {
      duplicates.add(word);
    } else {
      seen.add(key);
    }
  }
  return Array.from(duplicates);
};
const findChineseNumberWithSymbolsDuplicates = (input: string): string[] => {
  // 支持逗号分隔或换行分隔
  const items: string[] = input
    .split(/,|\r?\n/)
    .map(item => item.trim())
    .filter(Boolean);

  // 统一格式：提取外部符号、内容，内容转小写
  const normalize = (w: string): string => {
    if (typeof w !== "string") return "";
    // 匹配外部符号和内容
    const match = w.match(/^([^\w\u4e00-\u9fa5\d]*)([\u4e00-\u9fa5\d]+)([^\w\u4e00-\u9fa5\d]*)$/i);
    if (!match) return w.toLowerCase();
    // 保留外部符号和内容，内容转小写
    return `${match[1] || ""}${match[2].toLowerCase()}${match[3] || ""}`;
  };

  const seen = new Set<string>();
  const duplicates = new Set<string>();
  for (const word of items) {
    const key = normalize(word);
    if (!key) continue;
    if (seen.has(key)) {
      duplicates.add(word);
    } else {
      seen.add(key);
    }
  }
  return Array.from(duplicates);
};
export const getUrlParams = (search: string) => {
  let params: any = {};
  search = search.substring(1);
  if (search) {
    const paramArr = search.split("&");
    paramArr.forEach(param => {
      const paramPair = param.split("=");
      params[paramPair[0]] = decodeURIComponent(paramPair[1]);
    });
  }
  return params;
};

export const deleteParam = (search: string, paramKey: string) => {
  const params: any = getUrlParams(search);
  delete params[paramKey];
  return params;
};

export const updateURL = (params: any) => {
  let search = Object.keys(params)
    .map(paramKey => {
      return encodeURIComponent(paramKey) + "=" + encodeURIComponent(params[paramKey]);
    })
    .join("&");
  return "?" + search;
};

/**
 * 安全的字符串长度计算函数（按显示宽度计算）
 * 包含XSS防护、输入验证和类型检查
 *
 * @param str - 要计算长度的字符串
 * @param options - 可选配置
 * @param options.maxLength - 最大允许长度（防DoS攻击）
 * @param options.allowHTML - 是否允许HTML内容（默认false）
 * @param options.sanitize - 是否自动清理危险内容（默认true）
 * @returns 字符串的显示宽度长度，出错时返回0
 */
// 缓存正则表达式以提高性能
const SECURITY_PATTERNS = {
  // HTML标签 - 更严格的匹配
  HTML: /<[^>]*>/gi,

  // JavaScript伪协议 - 匹配javascript:后跟函数调用
  JS_PROTOCOL: /javascript\s*:\s*[^(\s]*\([^)]*\)/gi,

  // Data URL中的HTML/脚本
  DATA_URL: /data\s*:\s*(?:text\/html|application\/javascript)/gi,

  // 事件处理器 - 匹配常见的事件处理器模式，支持引号和函数调用
  EVENT_HANDLER: /on\w+\s*=\s*(?:"[^"]*"|'[^']*'|\w+\([^)]*\))/gi,

  // CSS表达式攻击 - 匹配expression到第一个平衡的右括号
  CSS_EXPRESSION: /expression\s*\((?:[^()]*|\([^()]*\))*\)/gi,

  // VBSCRIPT协议 - 匹配vbscript:后跟函数调用
  VBS_PROTOCOL: /vbscript\s*:\s*[^(\s]*\([^)]*\)/gi,

  // Base64编码的脚本
  BASE64_SCRIPT: /data:[^;]*;base64,[a-zA-Z0-9+/=]*(?:script|javascript|vbscript)/gi,

  // 非ASCII字符混淆攻击（零宽字符等）
  ZERO_WIDTH: /[\u200B-\u200D\uFEFF]/g,

  // HTML实体编码的脚本
  HTML_ENTITIES: /&(?:#(?:x[0-9a-fA-F]+|\d+)|[a-zA-Z][a-zA-Z0-9]*);/g,

  // SVG脚本攻击
  SVG_SCRIPT: /<svg[^>]*>[\s\S]*?<script[\s\S]*?<\/script>[\s\S]*?<\/svg>/gi,

  // 不可见Unicode控制字符
  // eslint-disable-next-line no-control-regex
  CONTROL_CHARS: /[\u0000-\u001F\u007F-\u009F]/g,
} as const;

/**
 * 安全威胁检测结果接口
 */
interface SecurityThreatResult {
  hasThreats: boolean;
  detectedThreats: Array<{
    name: string;
    severity: "warning" | "error" | "critical";
    userMessage: string;
  }>;
  // 新增：清理后的结果
  cleanedString?: string;
  originalLength?: number;
  cleanedLength?: number;
  cleaningSummary?: string;
}

/**
 * 检测字符串中的安全威胁
 * @param str 要检查的字符串
 * @param autoClean 是否自动清理威胁（默认false，仅检测）
 * @returns 威胁检测结果
 */
export const detectSecurityThreats = (str: string, autoClean = false): SecurityThreatResult => {
  const patterns = SECURITY_PATTERNS;
  let hasThreats = false;

  // 定义威胁检测规则（包含可清理和不可清理的威胁类型）
  const threats = [
    {
      name: "HTML Tags",
      pattern: new RegExp(patterns.HTML.source, patterns.HTML.flags),
      severity: "warning" as const,
      canAutoClean: true,
      messages: {
        detected: "输入内容包含HTML标签，请检查后重试",
        cleaned: "输入内容包含HTML标签，已自动清理",
      },
    },
    {
      name: "JavaScript Protocol",
      pattern: new RegExp(patterns.JS_PROTOCOL.source, patterns.JS_PROTOCOL.flags),
      severity: "critical" as const,
      canAutoClean: true,
      messages: {
        detected: "检测到JavaScript注入攻击，请检查输入内容",
        cleaned: "检测到JavaScript注入攻击，已自动清理",
      },
    },
    {
      name: "Data URL",
      pattern: new RegExp(patterns.DATA_URL.source, patterns.DATA_URL.flags),
      severity: "error" as const,
      canAutoClean: true,
      messages: {
        detected: "检测到不安全的Data URL，请使用其他方式",
        cleaned: "检测到不安全的Data URL，已自动清理",
      },
    },
    {
      name: "Event Handlers",
      pattern: new RegExp(patterns.EVENT_HANDLER.source, patterns.EVENT_HANDLER.flags),
      severity: "critical" as const,
      canAutoClean: true,
      messages: {
        detected: "检测到事件处理器注入，请检查输入内容",
        cleaned: "检测到事件处理器注入，已自动清理",
      },
    },
    {
      name: "CSS Expression",
      pattern: new RegExp(patterns.CSS_EXPRESSION.source, patterns.CSS_EXPRESSION.flags),
      severity: "critical" as const,
      canAutoClean: true,
      messages: {
        detected: "检测到CSS表达式注入攻击，请检查输入内容",
        cleaned: "检测到CSS表达式注入攻击，已自动清理",
      },
    },
    {
      name: "VBScript Protocol",
      pattern: new RegExp(patterns.VBS_PROTOCOL.source, patterns.VBS_PROTOCOL.flags),
      severity: "critical" as const,
      canAutoClean: true,
      messages: {
        detected: "检测到VBScript注入攻击，请检查输入内容",
        cleaned: "检测到VBScript注入攻击，已自动清理",
      },
    },
    {
      name: "Base64 Script",
      pattern: new RegExp(patterns.BASE64_SCRIPT.source, patterns.BASE64_SCRIPT.flags),
      severity: "critical" as const,
      canAutoClean: true,
      messages: {
        detected: "检测到Base64编码的脚本注入，请检查输入内容",
        cleaned: "检测到Base64编码的脚本注入，已自动清理",
      },
    },
    {
      name: "Zero Width Characters",
      pattern: new RegExp(patterns.ZERO_WIDTH.source, patterns.ZERO_WIDTH.flags),
      severity: "warning" as const,
      canAutoClean: true,
      messages: {
        detected: "输入内容包含零宽字符，请检查后重试",
        cleaned: "输入内容包含零宽字符，已自动清理",
      },
    },
    {
      name: "HTML Entities",
      pattern: new RegExp(patterns.HTML_ENTITIES.source, patterns.HTML_ENTITIES.flags),
      severity: "warning" as const,
      canAutoClean: true,
      messages: {
        detected: "输入内容包含HTML实体编码，请检查后重试",
        cleaned: "输入内容包含HTML实体编码，已自动清理",
      },
    },
    {
      name: "SVG Script",
      pattern: new RegExp(patterns.SVG_SCRIPT.source, patterns.SVG_SCRIPT.flags),
      severity: "critical" as const,
      canAutoClean: true,
      messages: {
        detected: "检测到SVG脚本注入攻击，请检查输入内容",
        cleaned: "检测到SVG脚本注入攻击，已自动清理",
      },
    },
    {
      name: "Control Characters",
      pattern: new RegExp(patterns.CONTROL_CHARS.source, patterns.CONTROL_CHARS.flags),
      severity: "warning" as const,
      canAutoClean: true,
      messages: {
        detected: "输入内容包含控制字符，请检查后重试",
        cleaned: "输入内容包含控制字符，已自动清理",
      },
    },
  ];

  // 检测威胁
  const detectedThreats: Array<{
    name: string;
    severity: "warning" | "error" | "critical";
    userMessage: string;
  }> = [];

  for (const threat of threats) {
    if (threat.pattern.test(str)) {
      detectedThreats.push({
        name: threat.name,
        severity: threat.severity,
        userMessage: autoClean ? threat.messages.cleaned : threat.messages.detected,
      });
      hasThreats = true;
    }
  }

  // 如果需要自动清理，执行清理操作
  let cleanedString = str;
  const originalLength = str.length;
  let cleanedLength = originalLength;
  let cleaningSummary = "";

  if (autoClean && hasThreats) {
    const patterns = SECURITY_PATTERNS;
    const cleanedThreats: string[] = [];

    // 根据检测到的威胁进行清理
    for (const detectedThreat of detectedThreats) {
      const threatName = detectedThreat.name;

      // 根据威胁名称选择对应的清理模式
      switch (threatName) {
        case "HTML Tags":
          cleanedString = cleanedString.replace(patterns.HTML, "");
          cleanedThreats.push("HTML标签");
          break;
        case "JavaScript Protocol":
          cleanedString = cleanedString.replace(patterns.JS_PROTOCOL, "");
          cleanedThreats.push("JavaScript协议");
          break;
        case "Data URL":
          cleanedString = cleanedString.replace(patterns.DATA_URL, "");
          cleanedThreats.push("Data URL");
          break;
        case "Event Handlers":
          cleanedString = cleanedString.replace(patterns.EVENT_HANDLER, "");
          cleanedThreats.push("事件处理器");
          break;
        case "CSS Expression":
          cleanedString = cleanedString.replace(patterns.CSS_EXPRESSION, "");
          cleanedThreats.push("CSS表达式");
          break;
        case "VBScript Protocol":
          cleanedString = cleanedString.replace(patterns.VBS_PROTOCOL, "");
          cleanedThreats.push("VBScript协议");
          break;
        case "Base64 Script":
          cleanedString = cleanedString.replace(patterns.BASE64_SCRIPT, "");
          cleanedThreats.push("Base64脚本");
          break;
        case "Zero Width Characters":
          cleanedString = cleanedString.replace(patterns.ZERO_WIDTH, "");
          cleanedThreats.push("零宽字符");
          break;
        case "HTML Entities":
          cleanedString = cleanedString.replace(patterns.HTML_ENTITIES, "");
          cleanedThreats.push("HTML实体");
          break;
        case "SVG Script":
          cleanedString = cleanedString.replace(patterns.SVG_SCRIPT, "");
          cleanedThreats.push("SVG脚本");
          break;
        case "Control Characters":
          cleanedString = cleanedString.replace(patterns.CONTROL_CHARS, "");
          cleanedThreats.push("控制字符");
          break;
        default:
          break;
      }
    }

    // 额外的清理：移除可能的混淆字符组合
    cleanedString = cleanedString
      .replace(/\s{2,}/g, " ") // 多个空格合并为一个
      .trim(); // 去除首尾空格

    cleanedLength = cleanedString.length;
    cleaningSummary = `已清理: ${cleanedThreats.join("、")}。原长度: ${originalLength}，清理后长度: ${cleanedLength}`;
  }

  const result: SecurityThreatResult = {
    hasThreats,
    detectedThreats,
  };

  // 如果执行了清理，添加清理相关信息
  if (autoClean) {
    result.cleanedString = cleanedString;
    result.originalLength = originalLength;
    result.cleanedLength = cleanedLength;
    if (hasThreats) {
      result.cleaningSummary = cleaningSummary;
    }
  }

  return result;
};

/**
 * 安全检查和清理字符串
 * @param str 要检查的字符串
 * @param allowHTML 是否允许HTML内容
 * @param strictMode 是否启用严格模式（检测到严重威胁时抛出SecurityError）
 * @returns 清理后的字符串
 */
const sanitizeString = (str: string, allowHTML = false, strictMode = false): string => {
  if (allowHTML) return str;

  let cleanStr = str;

  // 使用独立的威胁检测方法
  const threatResult = detectSecurityThreats(str);
  const { hasThreats, detectedThreats } = threatResult;

  // 如果检测到威胁，进行处理
  if (hasThreats) {
    const threatNames = detectedThreats.map(t => t.name).join(", ");
    console.warn(`Security threats detected: ${threatNames}`);

    // 在严格模式下，对于关键威胁抛出SecurityError
    if (strictMode) {
      const criticalThreats = detectedThreats.filter(t => t.severity === "critical");
      if (criticalThreats.length > 0) {
        const criticalThreat = criticalThreats[0]; // 取第一个关键威胁
        throw new SecurityError(
          `Critical security threat detected: ${criticalThreat.name}`,
          "CRITICAL_SECURITY_THREAT",
          "critical",
          criticalThreat.userMessage,
          {
            threats: detectedThreats,
            originalContent: str.substring(0, 100) + "...",
          }
        );
      }
    }

    // 基于检测到的威胁进行清理
    const patterns = SECURITY_PATTERNS;

    // 依次清理所有检测到的威胁类型
    for (const detectedThreat of detectedThreats) {
      const threatName = detectedThreat.name;

      // 根据威胁名称选择对应的清理模式
      switch (threatName) {
        case "HTML Tags":
          cleanStr = cleanStr.replace(patterns.HTML, "");
          break;
        case "JavaScript Protocol":
          cleanStr = cleanStr.replace(patterns.JS_PROTOCOL, "");
          break;
        case "Data URL":
          cleanStr = cleanStr.replace(patterns.DATA_URL, "");
          break;
        case "Event Handlers":
          cleanStr = cleanStr.replace(patterns.EVENT_HANDLER, "");
          break;
        case "CSS Expression":
          cleanStr = cleanStr.replace(patterns.CSS_EXPRESSION, "");
          break;
        case "VBScript Protocol":
          cleanStr = cleanStr.replace(patterns.VBS_PROTOCOL, "");
          break;
        case "Base64 Script":
          cleanStr = cleanStr.replace(patterns.BASE64_SCRIPT, "");
          break;
        case "Zero Width Characters":
          cleanStr = cleanStr.replace(patterns.ZERO_WIDTH, "");
          break;
        case "HTML Entities":
          cleanStr = cleanStr.replace(patterns.HTML_ENTITIES, "");
          break;
        case "SVG Script":
          cleanStr = cleanStr.replace(patterns.SVG_SCRIPT, "");
          break;
        case "Control Characters":
          cleanStr = cleanStr.replace(patterns.CONTROL_CHARS, "");
          break;
        default:
          break;
      }
    }

    // 额外的清理：移除可能的混淆字符组合
    cleanStr = cleanStr
      .replace(/\s{2,}/g, " ") // 多个空格合并为一个
      .trim(); // 去除首尾空格
  }

  return cleanStr;
};

/**
 * 计算字符的显示宽度
 * @param charCode 字符编码
 * @returns 字符宽度（1或2）
 */
const getCharWidth = (charCode: number): number => {
  // 半角字符：ASCII基本字符 + 半角片假名
  return (charCode >= 0x0001 && charCode <= 0x007e) || (charCode >= 0xff60 && charCode <= 0xff9f) ? 1 : 2;
};

export const strlen = (
  str: string,
  options?: {
    maxLength?: number;
    allowHTML?: boolean;
    sanitize?: boolean;
    strictMode?: boolean; // 新增：严格模式
  }
): number => {
  const { maxLength = 10000, allowHTML = false, sanitize = true, strictMode = false } = options || {};

  try {
    // 1. 输入验证和类型检查
    if (str == null) return 0;

    if (typeof str !== "string") {
      if (strictMode) {
        console.error("strlen: Input must be a string in strict mode - converting to string");
      }
      console.warn("strlen: Input is not a string, converting to string");
      str = String(str);
    }

    // 2. 严格模式下的额外验证
    if (strictMode) {
      // 检查字符串是否包含null字节
      if (str.includes("\0")) {
        console.error("strlen: String contains null bytes - removing null bytes");
        str = str.replace(/\0/g, "");
      }

      // 检查是否有过长的单行（可能是攻击）
      const lines = str.split(/\r?\n/);
      const maxLineLength = Math.min(maxLength, 1000);
      for (let i = 0; i < lines.length; i++) {
        if (lines[i].length > maxLineLength) {
          console.error(`strlen: Line ${i + 1} exceeds maximum length ${maxLineLength} - truncating line`);
          lines[i] = lines[i].substring(0, maxLineLength);
        }
      }
      str = lines.join("\n");
    }

    // 3. 长度限制检查（防DoS攻击）
    if (str.length > maxLength) {
      const action = strictMode ? "truncating in strict mode" : "truncating";
      const message = `strlen: Input exceeds maximum length ${maxLength}, ${action}`;

      if (strictMode) {
        console.error(message);
      } else {
        console.warn(message);
      }

      str = str.substring(0, maxLength);
    }

    // 4. 安全检查：检测潜在的恶意内容
    if (sanitize) {
      const originalLength = str.length;
      str = sanitizeString(str, allowHTML, strictMode);

      // 如果内容被大幅修改，在严格模式下记录错误但继续执行
      if (strictMode && str.length < originalLength * 0.5) {
        console.error("strlen: Too much content was sanitized, possible attack - continuing with sanitized content");
      }
    }

    // 5. 计算显示宽度（优化后的循环）
    let len = 0;
    for (let i = 0; i < str.length; i++) {
      const charCode = str.charCodeAt(i);

      // 在严格模式下检查可疑的Unicode字符
      if (strictMode && (charCode > 0xffff || (charCode < 0x20 && charCode !== 0x09 && charCode !== 0x0a && charCode !== 0x0d))) {
        console.warn(`strlen: Suspicious character detected at position ${i}: U+${charCode.toString(16).toUpperCase()}`);
      }

      len += getCharWidth(charCode);
    }

    return len;
  } catch (error) {
    // 如果是SecurityError，重新抛出让前端处理
    if (error instanceof SecurityError) {
      throw error;
    }
    // 其他错误记录并返回安全值
    console.error("strlen: Unexpected error occurred - returning 0", error);
    return 0;
  }
};
// 改进的类型定义
declare global {
  interface String {
    strSlice(start: number, end: number, options?: { sanitize?: boolean; strictMode?: boolean }): string;
  }
}

/**
 * 安全的字符串截取方法（按显示宽度截取）
 * 包含安全验证和错误处理
 */
String.prototype.strSlice = function (start: number, end: number, options?: { sanitize?: boolean; strictMode?: boolean }): string {
  const { sanitize = true, strictMode = false } = options || {};

  try {
    let str = this as string;

    // 输入验证
    if (typeof str !== "string") {
      const message = "strSlice: Input is not a string";
      if (strictMode) {
        console.error(message);
      } else {
        console.warn(message);
      }
      return "";
    }

    // 参数验证 - 更严格的检查
    if (!Number.isInteger(start) || !Number.isInteger(end)) {
      const message = "strSlice: start and end must be integers - converting to integers";
      if (strictMode) {
        console.error(message);
      } else {
        console.warn(message);
      }
      start = Math.floor(Number(start)) || 0;
      end = Math.floor(Number(end)) || 0;
    }

    if (start < 0 || end < 0) {
      const message = "strSlice: start and end must be non-negative - adjusting to 0";
      if (strictMode) {
        console.error(message);
      } else {
        console.warn(message);
      }
      start = Math.max(0, start);
      end = Math.max(0, end);
    }

    if (start >= end) {
      const message = "strSlice: start must be less than end - returning empty string";
      if (strictMode) {
        console.error(message);
      } else {
        console.warn(message);
      }
      return "";
    }

    // 防止过大的截取范围
    const maxRange = 100000;
    if (end - start > maxRange) {
      const message = `strSlice: Range too large (${end - start}), maximum allowed is ${maxRange} - adjusting range`;
      if (strictMode) {
        console.error(message);
      } else {
        console.warn(message);
      }
      end = start + maxRange;
    }

    // 安全检查（复用sanitizeString函数）
    if (sanitize) {
      const originalLength = str.length;
      str = sanitizeString(str, false, strictMode);

      // 如果内容被大幅修改，在严格模式下记录错误但继续执行
      if (strictMode && str.length < originalLength * 0.5) {
        console.error("strSlice: Too much content was sanitized, possible attack - continuing with sanitized content");
      }
    }

    // 优化后的字符截取逻辑
    let currentWidth = 0;
    let result = "";

    for (let i = 0; i < str.length && currentWidth < end; i++) {
      const charCode = str.charCodeAt(i);
      const charWidth = getCharWidth(charCode);

      // 在严格模式下检查可疑字符
      if (strictMode && (charCode > 0xffff || (charCode < 0x20 && charCode !== 0x09 && charCode !== 0x0a && charCode !== 0x0d))) {
        console.warn(`strSlice: Suspicious character detected at position ${i}: U+${charCode.toString(16).toUpperCase()}`);
      }

      // 如果当前字符会导致宽度超过起始位置，开始收集字符
      if (currentWidth + charWidth > start) {
        result += str[i];
      }

      currentWidth += charWidth;

      // 如果达到结束位置，停止收集
      if (currentWidth >= end) {
        break;
      }
    }

    return result;
  } catch (error) {
    // 如果是SecurityError，重新抛出让前端处理
    if (error instanceof SecurityError) {
      throw error;
    }
    // 其他错误记录并返回安全值
    console.error("strSlice: Unexpected error occurred - returning empty string", error);
    return "";
  }
};
export const isHTML = (text: any) => {
  const nameAndAddress = /^[\u4E00-\u9FA5A-Za-z0-9_\-—.\s/()（）,#]+$/g;
  const verify = /<[\u4E00-\u9FA50-9][\s\S]*?>?/i;
  return !nameAndAddress.test(text.trim()) && !verify.test(text.trim());
};

export const getOptions = (list: any) => {
  return (
    list?.map((item: any, index: number) => ({
      key: (index + 1).toString(),
      text: item,
    })) || []
  );
};

export const verifyUrl = (url: string) => {
  const regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&%'\*\+,;=.]+$/i;
  return regex.test(url);
};
export const verifyHttpsUrl = (url: string) => {
  const regex = /^https:\/\/?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&%'\*\+,;=.]+$/i;
  return regex.test(url);
};
export const verifyNumber = (value: string) => {
  const regex = /^(?!0\d)\d{1,9}(\.\d{1,4})?$/;
  return regex.test(value);
};

export const verify5to12 = (value: string) => {
  const regex = /^[0-9a-zA-Z]{5,12}$/;
  return regex.test(value);
};

export const retain = (value: any, n: any) => {
  if (n === "null" || n === "undefined" || n === 0) return parseInt(value);
  let tran = Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
  let tranV = tran.toString();
  let newVal = tranV.indexOf(".");
  if (newVal < 0) {
    tranV += ".";
  }
  for (let i = tranV.length - tranV.indexOf("."); i <= n; i++) {
    tranV += "0";
  }
  return tranV;
};
const keepDigitDecimal = (num: any, n: any) => {
  // 小于零，先转正数计算
  if (num < 0) {
    return (Math.floor(-1 * num * 10 ** n) / 10 ** n) * -1;
  }

  return Math.floor(num * 10 ** n) / 10 ** n;
};
export const reserveFloat = (data: any, n: any) => {
  // let value: any = Math.floor(parseFloat(data) * 100) / 100;
  let value: any = keepDigitDecimal(data, n);
  let res = value.toString().split(".");
  if (res.length === 1) {
    return value + ".00";
  }
  if (res.length > 1) {
    if (res[1].length < 2) {
      value = value.toString() + "0";
    }
    return value;
  }
};

export const toLower = (str: string) => {
  return str !== undefined ? str.toLocaleLowerCase() : "";
};

export const toUpper = (str: string) => {
  return str !== undefined ? str.toLocaleUpperCase() : "";
};

export const getChannel = (channel: string) => {
  return toLower(channel) === "pc" ? "PC" : "Mobile";
};
export const uniqueArray = (arr: any) => {
  const seen = new Set();
  return arr.filter((item: any) => {
    const key = JSON.stringify(item);
    return seen.has(key) ? false : seen.add(key);
  });
};

export const timeConversion = (date: string) => {
  return JSON.stringify(new Date(date)).substr(1, 24);
};

interface ConvertToTimeZoneProps {
  date: string | Date | number;
  format?: string;
}
export const convertToTimeZone = ({ date, format = "YYYY-MM-DD" }: ConvertToTimeZoneProps): string => {
  return dayjs.tz(new Date(date)).format(format);
};

export const convertToTimeZone1 = (date: string | Date, format?: string) => {
  return dayjs.tz(new Date(date)).format(format);
};

export const getTimeZone = (date: Date, timeZone: number): Date => {
  const utcDate = new Date(date).toISOString();
  let T_pos = utcDate.indexOf("T");
  let Z_pos = utcDate.indexOf("Z");
  let year_month_day = utcDate.substr(0, T_pos);
  let hour_minute_second = utcDate.substr(T_pos + 1, Z_pos - T_pos - 1);
  let new_datetime = year_month_day + " " + hour_minute_second;

  // eslint-disable-next-line no-var
  timestamp = new Date(Date.parse(new_datetime));
  timestamp = timestamp.getTime();
  timestamp = timestamp / 1000;
  var timestamp: any = timestamp + timeZone * 60 * 60;
  return new Date(parseInt(timestamp) * 1000);
};

// 时区缓存，避免重复计算
let cachedCustomerTimezone: string | null = null;
let cachedCustomerId: number | null = null;

// 清除时区缓存（在账户/客户切换时调用）
export const clearTimezoneCache = (): void => {
  cachedCustomerTimezone = null;
  cachedCustomerId = null;
};

// 获取客户时区配置
export const getCustomerTimezone = (): string => {
  try {
    // 检查缓存
    const currentCustomer = localData("currentCustomer");
    const currentCustomerId = currentCustomer?.customerId;

    if (cachedCustomerTimezone !== null && cachedCustomerId === currentCustomerId) {
      return cachedCustomerTimezone as string;
    }

    // 1. 优先从客户数据中获取时区配置（如果有的话）
    if (currentCustomer?.region) {
      cachedCustomerTimezone = currentCustomer.region === "non-cn" ? "Asia/Tokyo" : "Asia/Shanghai";
      cachedCustomerId = currentCustomerId;
      return cachedCustomerTimezone as string;
    }

    // 2. 根据客户区域推断时区
    const region = getCurrentInfo("region");
    let timezone = getBusinessTimezone(); // 默认时区

    if (region) {
      const normalizedRegion = region.toLowerCase();
      // 根据区域映射到相应时区
      if (normalizedRegion === "zh-cn" || normalizedRegion === "cn") {
        timezone = "Asia/Shanghai";
      } else if (normalizedRegion === "ja-jp" || normalizedRegion === "jp" || normalizedRegion === "non-cn") {
        timezone = "Asia/Tokyo";
      } else if (normalizedRegion === "en-us" || normalizedRegion === "us") {
        timezone = "America/New_York";
      } else if (normalizedRegion === "en-gb" || normalizedRegion === "gb") {
        timezone = "Europe/London";
      }
      // 可根据需要添加更多区域映射
    }

    // 缓存结果
    cachedCustomerTimezone = timezone;
    cachedCustomerId = currentCustomerId;

    return timezone;
  } catch (error) {
    console.warn("getCustomerTimezone: Error getting customer timezone:", error);
    const fallback = getBusinessTimezone();
    cachedCustomerTimezone = fallback;
    return fallback;
  }
};

export const getutcOffset = (): number => {
  try {
    // 获取客户时区偏移，优先级：客户配置 > 区域推断 > 本地时区
    const customerTimezone = getCustomerTimezone();
    return dayjs.tz(new Date(), customerTimezone).utcOffset() / 60;
  } catch (error) {
    console.warn("getutcOffset: Failed to get customer timezone, using local timezone:", error);
    // 回退到本地时区
    return dayjs.tz().utcOffset() / 60;
  }
};

// 添加一个获取业务时区的函数
export const getBusinessTimezone = (): string => {
  try {
    // 根据客户区域确定默认业务时区
    const region = getCurrentInfo("region");
    if (region) {
      const normalizedRegion = region.toLowerCase();
      if (normalizedRegion === "zh-cn" || normalizedRegion === "cn") {
        return "Asia/Shanghai";
      } else if (normalizedRegion === "ja-jp" || normalizedRegion === "jp" || normalizedRegion === "non-cn") {
        return "Asia/Tokyo";
      } else if (normalizedRegion === "en-us" || normalizedRegion === "us") {
        return "America/New_York";
      } else if (normalizedRegion === "en-gb" || normalizedRegion === "gb") {
        return "Europe/London";
      }
    }

    // 如果无法确定区域，默认使用中国时区（主要业务区域）
    return "Asia/Shanghai";
  } catch (error) {
    console.warn("getBusinessTimezone: Error determining business timezone:", error);
    return "Asia/Shanghai";
  }
};

// 安全的时区转换函数
export const convertToBusinessTime = (date: Date | string): string => {
  try {
    const customerTimezone = getCustomerTimezone();
    return dayjs.tz(date, customerTimezone).toISOString();
  } catch (error) {
    console.error("convertToBusinessTime error:", error);
    // 回退到本地时区
    return dayjs(date).toISOString();
  }
};

export const getTimeZoneDate = (date: Date | string, showHour?: boolean, separator?: string): string => {
  const separ = separator || "-";
  const isShowHour = showHour || false;
  return isShowHour ? getDateShowHours(date, separ) : getDate(date, separ);
};
export const getTimeZoneHour = (date: Date): string => {
  const utcDate = getTimeZone(new Date(date), getutcOffset());
  return ("0" + utcDate.getHours()).slice(-2) + ":" + ("0" + utcDate.getMinutes()).slice(-2);
};

export const getTimeZoneDateTime = (date: Date | string, targetTimezone?: string): string => {
  try {
    // 输入验证
    if (date === null || date === undefined) {
      throw new Error("Date cannot be null or undefined");
    }

    // 类型验证
    if (typeof date === "string") {
      const parsed = new Date(date);
      if (isNaN(parsed.getTime())) {
        throw new Error("Invalid date string format");
      }
    } else if (date instanceof Date) {
      if (isNaN(date.getTime())) {
        throw new Error("Invalid Date object");
      }
    } else {
      throw new Error("Date must be a Date object or valid date string");
    }

    // 确定目标时区，优先级：参数 > 客户时区 > 用户本地时区 > 业务默认时区
    const timezone = targetTimezone || getCustomerTimezone();

    const result = dayjs.tz(date, timezone);
    if (!result.isValid()) {
      throw new Error("dayjs failed to parse the date");
    }

    return result.toISOString();
  } catch (error: any) {
    console.error("getTimeZoneDateTime error:", error);
    throw new Error(`Failed to convert date to timezone datetime: ${error?.message || "Unknown error"}`);
  }
};

export const getTimeZoneDateTimeFormat = (date: Date | string, separator?: string): string => {
  const separ = separator || "-";
  return dayjs(getTimeZone(new Date(date), getutcOffset())).format(`YYYY${separ}MM${separ}DD`);
};

export const getDateShowHours = (date: Date | string, separator?: string) => {
  const separ = separator || "-";
  return dayjs(getTimeZone(new Date(date), getutcOffset())).format(`YYYY${separ}MM${separ}DD HH:mm`);
};

export const getDate = (date: Date | string, separator?: string) => {
  const separ = separator || "-";
  return dayjs(getTimeZone(new Date(date), getutcOffset())).format(`YYYY${separ}MM${separ}DD`);
};

export const getDateFormat = (date: Date | string, format?: string) => {
  const formatData = format || "YYYY/MM/DD";
  return dayjs(getTimeZone(new Date(date), getutcOffset())).format(formatData);
};

export const getTime = (data: any) => {
  return getTimeZoneDate(data) + " " + incrementSecondsIfFiftyNine(ToHours(data));
};

// 国际化版本的DateGridStrings生成函数
export const createDateGridStringsI18n = (t: TFunction): IDateGridStrings => ({
  months: [
    t("Common.dateTime.months.january"),
    t("Common.dateTime.months.february"),
    t("Common.dateTime.months.march"),
    t("Common.dateTime.months.april"),
    t("Common.dateTime.months.may"),
    t("Common.dateTime.months.june"),
    t("Common.dateTime.months.july"),
    t("Common.dateTime.months.august"),
    t("Common.dateTime.months.september"),
    t("Common.dateTime.months.october"),
    t("Common.dateTime.months.november"),
    t("Common.dateTime.months.december"),
  ],
  shortMonths: [
    t("Common.dateTime.monthsShort.january"),
    t("Common.dateTime.monthsShort.february"),
    t("Common.dateTime.monthsShort.march"),
    t("Common.dateTime.monthsShort.april"),
    t("Common.dateTime.monthsShort.may"),
    t("Common.dateTime.monthsShort.june"),
    t("Common.dateTime.monthsShort.july"),
    t("Common.dateTime.monthsShort.august"),
    t("Common.dateTime.monthsShort.september"),
    t("Common.dateTime.monthsShort.october"),
    t("Common.dateTime.monthsShort.november"),
    t("Common.dateTime.monthsShort.december"),
  ],
  days: [
    t("Common.dateTime.weekdays.sunday"),
    t("Common.dateTime.weekdays.monday"),
    t("Common.dateTime.weekdays.tuesday"),
    t("Common.dateTime.weekdays.wednesday"),
    t("Common.dateTime.weekdays.thursday"),
    t("Common.dateTime.weekdays.friday"),
    t("Common.dateTime.weekdays.saturday"),
  ],
  shortDays: [
    t("Common.dateTime.weekdaysShort.sunday"),
    t("Common.dateTime.weekdaysShort.monday"),
    t("Common.dateTime.weekdaysShort.tuesday"),
    t("Common.dateTime.weekdaysShort.wednesday"),
    t("Common.dateTime.weekdaysShort.thursday"),
    t("Common.dateTime.weekdaysShort.friday"),
    t("Common.dateTime.weekdaysShort.saturday"),
  ],
});
